/*
 * Поиск ближайшего (под собой реализует бинарный поиск)
 */
export const searchClosest = (num, array) => {
    let low = 0;
    let hight = array.length - 1;

    while (hight - low > 1) {
        let mid = Math.floor((low + hight) / 2);
        let guess = array[mid];

        if (guess < num) {
            low = mid;
        } else {
            hight = mid;
        }
    }

    if (num - array[low] <= array[hight] - num) {
        return low;
    }

    return hight;
};

/*
 * Для тестирования функции searchClosest
 */
// const arr = [-10, -8, -4, -2, 0, 2, 4, 8, 10];
// const f = -60;

// var t0 = performance.now();
// console.log(closest(f, arr));
// var t1 = performance.now();
// console.log('Call ' + (t1 - t0) + ' milliseconds.');
